export default __webpack_public_path__ + "static/media/ic_section_content.75e79a80.svg";